import { IBookingDiscountDetails } from "@/api_framework/api_modals/Bookings";
import SlideoverWithStickyFooter from "@/app/components/ui/SlideOvers/SlideoverWithStickyFooter";
import { useSlideoverState } from "@/app/hooks/ui_hooks/useSlideoverState";
import { useUtils } from "@/app/hooks/useUtils";
import { Tooltip } from "react-tooltip";

interface IInvoiceDetailsSlideoverState {
  inVoiceDetails: IBookingDiscountDetails;
}
const InvoiceDetailsSlideover = () => {
  const { inVoiceDetails } = useSlideoverState("CUSTOMER_PROFILE_DISCOUNT_DETAILS") as IInvoiceDetailsSlideoverState;
  const { truncateString } = useUtils();
  return (
    <SlideoverWithStickyFooter
      title={<span className="font-bold">Invoice Details</span>}
      slideoverId="CUSTOMER_PROFILE_DISCOUNT_DETAILS"
    >
      <div className="">
        <table className="min-w-full divide-y divide-gray-300  ">
          <tbody className="divide-y divide-gray-200 bg-white">
            <tr>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                Service & Goods
              </td>

              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                {inVoiceDetails?.services_and_goods}
              </td>
            </tr>
            <tr>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                Discount Type
              </td>

              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                {inVoiceDetails?.discount_type}
              </td>
            </tr>

            <tr>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                Discount Name
              </td>

              <td
                className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0"
                data-tooltip-id="discount_name"
                data-tooltip-content={inVoiceDetails?.discount_name}
              >
                {truncateString(inVoiceDetails?.discount_name, 35)}
              </td>
            </tr>
            <tr>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                Discount Percent
              </td>

              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                {inVoiceDetails?.discount}
              </td>
            </tr>
            <tr>
              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                Final Price
              </td>

              <td className="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-0">
                {inVoiceDetails?.final_revenue}
              </td>
            </tr>
          </tbody>
        </table>
        <Tooltip id="discount_name" />
      </div>
    </SlideoverWithStickyFooter>
  );
};

export default InvoiceDetailsSlideover;
